// Values mirror the DSP (sidekick-quantum quantum-fe/src/theme/colors.ts) so the portal reads as one product with it.
export const brandColors = {
    primary: "#7c6ef0",
    primaryLight: "#9589f5",
    primaryDark: "#6b5dd3",

    secondary: "#9C27B0",
    secondaryLight: "#BA68C8",
    secondaryDark: "#7B1FA2",

    info: "#60a5fa",

    background: { light: "#f8f9fa", dark: "#0e0e10" },
    surface: { light: "#ffffff", dark: "#18181b" },
    surface2: { light: "#f1f3f5", dark: "#1e1e22" },
    surface3: { light: "#e9ecef", dark: "#26262b" },

    accent: "#7c6ef0",
    accentSoft: "rgba(124,110,240,0.12)",
    green: "#34d399",
    amber: "#fbbf24",
    red: "#f87171",

    txt: "#e4e4e7",
    txt2: "#a1a1aa",
    txt3: "#63636e",
    border: "rgba(255,255,255,0.08)",
    border2: "rgba(255,255,255,0.14)",

    lightTxt: "#18181b",
    lightTxt2: "#52525b",
    lightTxt3: "#a1a1aa",
    lightBorder: "rgba(0,0,0,0.08)",
    lightBorder2: "rgba(0,0,0,0.14)",
} as const;

// Fixed in both themes, as in the DSP sidebar.
export const sidebarColors = {
    background: "#16171a",
    text: "#B6BAC3",
    selected: "#2e3138",
} as const;

// The DSP chart's series colours, mapped onto our three metrics.
export const seriesColors = {
    impressions: "#6366F1",
    installs: "#059669",
    visits: "#F97316",
} as const;

export const numericFontFamily = '"SF Pro Display", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif';
